<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="page-headline">
                    <h2>{{pageTitle}}</h2>
                    <h1>{{subTitle}}</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="margin-top: 45px;">
                <head-image
                        v-bind:imgURL="'https://www.robinjuenkersfeld.de/img/projects/rouge-et-noir-001.jpg'"
                        v-bind:imgTitle="'Rouge et Noir'"
                        v-bind:aspectratio="aspectratio" >
                </head-image>
            </div>
        </div>

        <div class="row">
            <div class="col-12 page-content">


                <span class="headline">Robin J&uuml;nkersfeld</span>
                <br/>Editor & Colorist
                <br/>
                <br/>mail: me@robinjuenkersfeld.de
                <br/>
                <br/>based in Berlin, Germany
            </div>
        </div>


    <div class="link_box">
        <a href='https://www.crew-united.com/?bio=203903' target="_blank">
            <img src='../assets/images/icons/logo-crew-united.png' width='109' height='20' border='0' alt='Crew United Profile'/>
        </a>
        <a href='https://www.linkedin.com/pub/robin-j%C3%BCnkersfeld/6a/5b3/545' target="_blank" style="margin-left: 20px;">
            <img src='../assets/images/icons/logo-linkedin.png' border='0' alt='Linkedin Profile'/>
        </a>
        <a href="https://www.xing.com/profile/Robin_Juenkersfeld" target="_blank" rel="me" style="margin-left: 20px;">
            <img src="../assets/images/icons/logo-xing.png" alt="Xing Profile" style="position:absolute; margin-top: -3px;">
        </a>
    </div>
    </div>

</template>

<script>
    import HeadImage from "@/components/HeadImage.vue";
    import {mapState} from 'vuex';

    export default {
        name: "kontakt-page",
        props: {
            project: {}
        },
        components: {
            HeadImage: HeadImage
        },
        data: function() {
            return {
                pageTitle: "About",
                subTitle: "Kontakt",
            };
        },
        computed: mapState({
            aspectratio: state => state.config.aspectratio
        }),
    };
</script>
